import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { SupplierWriteResponse } from '@/api/handlers/resources/suppliers/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { SupplierQueryKeys } from './supplierQueryKeys';

export type SetSupplierArchivedVariables = {
    id: string;
    archived: boolean;
};

/**
 * Archives or unarchives a supplier (BOS-121) — what a supplier with invoices,
 * payments or stock batches gets instead of a delete. Invalidates every
 * supplier query: archiving moves the row out of the picker and the default
 * list at once.
 */
export const useSetSupplierArchivedMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<SupplierWriteResponse>,
        Error,
        SetSupplierArchivedVariables
    >({
        mutationFn: ({ id, archived }) =>
            apiClient.suppliers.setSupplierArchived(id, archived),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: SupplierQueryKeys.all,
                });
            }
        },
    });
};
